var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 3.62808L20.5 3.12808L21.5 1.12808L19.036 1.82808C17.7285 0.608286 15.8209 0.282826 14.1829 1.00009C12.5449 1.71736 11.4903 3.33997 11.5 5.12808V6.12808C7.961 6.85808 4.866 4.92808 2 1.62808C1.5 4.29474 2 6.29474 3.5 7.62808L0.5 7.12808C0.905 9.19708 1.862 10.8281 4.5 11.1281L2 12.1281C3 14.1281 4.566 14.4381 7 14.6281C5.10692 15.9807 2.82603 16.6825 0.5 16.6281C13.255 22.2971 20.5 13.9641 20.5 6.62808V5.30008L22.5 3.62808Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.561d967f8546ef5e90b5fee091519b3f.svg";
export { ForwardRef as ReactComponent };